import React, { useEffect, useState } from "react";
import "./NotiItem.scss";
import truck from "@assets/icons/truck.svg";
import Helpers from "@utils/Helpers";
import { useNavigate } from "react-router-dom";
import { notificationApi } from "services/NotificationApi";
import { errorLog } from "logging";

interface INotiItem {
  type: string;
  message?: any;
  notification?: any;
}

const NotiItem: React.FC<INotiItem> = ({ type, message, notification }) => {
  const [content, setContent] = useState<string>("");
  const [time, setTime] = useState("0 min ago");
  const [isClickable, setIsClickable] = useState(
    notification?.is_clicked || false
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (message) {
      let notiContent = "";
      let notiTime = "";
      if (type == "Order") {
        notiContent = `You have new order. Order ID: ${message.order_id}`;
      } else {
        const messageNoti = message;
        const status = messageNoti.current_status;
        switch (status) {
          case 4:
            notiContent = `Your transaction #${messageNoti.transaction_id.slice(
              0,
              5
            )}... is confirmed and processing`;
            notiTime = Helpers.formatTimeAgo(messageNoti.time[1]);
            break;
          case 5:
            notiContent = `Your transaction #${messageNoti.transaction_id.slice(
              0,
              5
            )}... is Ready to Pickup`;
            notiTime = Helpers.formatTimeAgo(messageNoti.time[2]);
            break;
          case 7:
            notiContent = `Your transaction #${messageNoti.transaction_id.slice(
              0,
              5
            )}... is on its way`;
            notiTime = Helpers.formatTimeAgo(messageNoti.time[2]);
            break;
          case 8:
            notiContent = `Your transaction #${messageNoti.transaction_id.slice(
              0,
              5
            )}... is arrived`;
            notiTime = Helpers.formatTimeAgo(messageNoti.time[3]);
            break;
          default:
            notiContent = `Your transaction #${messageNoti.transaction_id.slice(
              0,
              5
            )}... is completed`;
            notiTime = Helpers.formatTimeAgo(messageNoti.time[4]);
            break;
        }
      }
      setContent(notiContent);
      setTime(notiTime);
    }
  }, [message]);

  useEffect(() => {
    if (notification) {
      setContent(notification.content);
      setTime(Helpers.formatTimeAgo(notification.created_at));
    }
  }, []);

  const handleClick = async () => {
    if (notification && !notification.is_clicked) {
      await handleUpdateClick();
    }
    if (type == "Order") {
      navigate(
        `/transaction?target=producer&id=${
          message ? message.object_id : notification.object_id
        }`
      );
    } else {
      navigate(
        `/transaction?target=${
          content.includes("completed") ? "producer" : "consumer"
        }&id=${message ? message.transaction_id : notification.object_id}`
      );
    }
  };

  const handleUpdateClick = async () => {
    try {
      const response = await notificationApi.updateClicked({
        notification_id: notification.notification_id,
        is_clicked: true,
      });
      if (response.status == 200) {
        setIsClickable(response.data.data.is_clicked);
      }
    } catch (error) {
      Helpers.notification.error("Can not update clicked");
      errorLog("NotiItem.tsx - handleUpdateClick", error);
    }
  };

  return (
    <div
      className={`NotiItem ${isClickable ? "clickable" : ""}`}
      onClick={handleClick}
    >
      <div className="item-icon">
        <img src={truck} alt="noti-icon" width={20} />
      </div>
      <div className="item-content">
        <div className="title">{content}</div>
        <div className="date">{time}</div>
      </div>
      <div className="item-status">
        <div className="dot"></div>
      </div>
    </div>
  );
};

export default NotiItem;
